import { QueryFunction, useQuery } from "react-query";
import { AxiosError } from "axios";

import { useSelectedProject } from "modules/projects/hooks/useSelectedProject";

import { fetchDashboardUsers } from "modules/core/api/dashboard";

import { IDashboardUsersResponse } from "modules/core/types/res";
import { RollupsType } from "modules/projects/types/entities";
import { DashboardUser } from "modules/core/types/entities";

export const DASHBOARD_USERS_QUERY_KEY = "/dashboard/users";

export type DashboardUsersQueryKey = [
  string,
  {
    project_id: string;
    rollups: RollupsType;
  }
];

const queryFn: QueryFunction<IDashboardUsersResponse, DashboardUsersQueryKey> =
  async ({ queryKey }) => {
    const [, { project_id, rollups }] = queryKey;

    return await fetchDashboardUsers({
      project_id,
      rollups
    });
  };

export const useDashboardUsersQuery = () => {
  const { selectedProject, rollupsType } = useSelectedProject();

  const results = useQuery<
    IDashboardUsersResponse,
    AxiosError,
    DashboardUser[],
    DashboardUsersQueryKey
  >(
    [
      DASHBOARD_USERS_QUERY_KEY,
      {
        project_id: selectedProject?.id || "",
        rollups: rollupsType
      }
    ],
    queryFn,
    {
      select: ({ data }) => data.map(item => item.attributes)
    }
  );

  return results;
};
